/* eslint-disable react/jsx-curly-newline */
import React, { useState, useEffect, ChangeEvent, useRef } from 'react';
import { Image, Tag, Upload, message } from 'antd';
import { useHistory } from 'react-router-dom';

import { MenuItem, makeStyles } from '@material-ui/core';
import { Profile } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/profile.interface';
import { Address } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/common.interface';
import { EOrderStatus } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/order.interface';
import { SearchBy } from 'src/component/Table/enums/searchby.enum';
import { useGetSuppliers } from 'src/reactQuery/suppliers/useGetSuppliers';
import Loader from 'src/component/Loader/Loader';
import { formatDate } from 'src/helpers/millisecondsToFormattedDate';
import CButton from 'src/component/Button';
import { CStandardInput } from 'src/component/Input';
import { DefaultSelect } from 'src/component/Select';
import { useGetGeneratedPassword } from 'src/reactQuery/users/queries/useGetGeneratedPassword';
import Modal from 'src/component/Modal/Modal';
import { uploadBannerImage } from 'src/services/napi';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { useCreateCustomer } from 'src/reactQuery/customers/mutations/useCreateCustomer';
import { useUpdateCustomerProfile } from 'src/reactQuery/customers/mutations/useUpdateCustomerProfile';
import { SupplierTableProps } from 'src/reactQuery/suppliers/interfaces/suppliers.interface';
import NotVerified from './svgs/NotVerified';
import { CreateSellerData } from './interfaces/seller.inteerface';
import { SellerCategories } from './enums/seller.enum';
import Verified from './svgs/Verified';
import NoxTable from '../../component/Table';
import InnerHeader from '../../component/InnerHeader';
import Copy from '../../component/Copy';
import OpenEye from '../../asset/eye-open.svg';
import ClosedEye from '../../asset/hide.svg';
import copyIcon from '../../asset/copy.svg';

const useStyles = makeStyles({
  garbage: {
    cursor: 'pointer',
    left: '24px',
    position: 'absolute'
  },
  passwordWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  root: {
    ' & .MuiInputBase-root': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      padding: '14px 16px'
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#9BA0AD'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontSize: '12px',
      left: '10px',
      top: '7px'
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(-10px, -10px) scale(0.83)'
    }
  },
  uploadWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  }
});

interface ProfileSettings {
  /** Is active seller */
  active: boolean;
  addresses?: Array<Address>;
  bankAccount?: string;
  hasBankAccount?: boolean;
}

const Sellers = () => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [edit, setEdit] = useState(false);
  // @ts-ignore
  const [sellerData, setSellerData] = useState<CreateSellerData>({});

  const [showPassword, setShowPassword] = useState(false);
  const [uploadedImage, setUploadedImage] = useState<string>('');

  const history = useHistory();
  const { data, isLoading, refetch } = useGetSuppliers();
  const { data: generatedPassword, refetch: refetchGeneratedPassword } = useGetGeneratedPassword();
  const { mutate: updateProfile } = useUpdateCustomerProfile({
    onSuccess: () => {
      refetch();
    }
  });
  const { mutate } = useCreateCustomer({
    onSuccess: (createdCustomerId) => {
      if (createdCustomerId) {
        setTimeout(() => {
          updateProfile({
            body: {
              ...sellerData,
              profilePictureId: uploadedImage,
              type: 'supplier',
              verified: true
            },
            profileId: createdCustomerId
          });
          history.push(`/authentication/customers/${createdCustomerId}`);
        }, 2000);
      }
    }
  });
  const classes = useStyles();
  const inputFile = useRef(null);

  const openDetail = (id: string) => {
    history.push({
      pathname: `/authentication/customers/${id}`
    });
  };

  const showModalHandler = () => {
    setEdit(false);
    setShowModal(true);
    refetchGeneratedPassword();
  };

  const clearInput = () => {
    // @ts-ignore
    setSellerData({});
    setShowPassword(false);
    setUploadedImage('');
  };

  const onCancel = () => {
    setShowModal(false);
    setEdit(false);
    clearInput();
  };

  const onSave = () => {
    if (!sellerData) return;

    mutate({
      email: sellerData.email,
      password: sellerData.password,
      username: sellerData.companyName
    });
    clearInput();
    setShowModal(false);
    setEdit(false);
  };

  const onGenericChange = (value: string, path: keyof CreateSellerData) => {
    setSellerData({
      ...sellerData,
      [path]: value
    });
  };

  const uploadRequest = async (data: any) => {
    const formData = new FormData();
    formData.append('file', data.file);

    if (!currentProject) return;

    const response = await uploadBannerImage(formData, currentProject._id!);
    // @ts-ignore
    if (response.data.success) {
      // @ts-ignore
      setUploadedImage(response.data.file._id);
    }

    message.success(`${data.file.name} file uploaded successfully`);
    data.onSuccess();
  };

  useEffect(() => {
    onGenericChange(generatedPassword, 'password');
  }, [generatedPassword]);

  const columns = [
    {
      dataIndex: 'companyId',
      key: 'companyId',
      render: (id: string) => {
        return <Copy text={id} />;
      },
      // @ts-ignore
      sorter: (a: Profile, b: Profile) => a._id.localeCompare(b._id),
      title: 'Company ID'
    },
    {
      dataIndex: 'companyName',
      key: 'companyName',
      render: (companyName: string) => {
        return <Copy text={companyName} />;
      },
      sorter: (a: SupplierTableProps, b: SupplierTableProps) =>
        a.companyName.toString().localeCompare(b.companyName),
      title: 'Full Name'
    },
    {
      dataIndex: 'email',
      key: 'email',
      render: (email: string) => {
        return <Copy text={email} />;
      },
      sorter: (a: SupplierTableProps, b: SupplierTableProps) =>
        a.email.toString().localeCompare(b.email),
      title: 'Email'
    },
    {
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      render: (phoneNumber: string) => {
        return <Copy text={phoneNumber} />;
      },
      sorter: (a: SupplierTableProps, b: SupplierTableProps) =>
        a.phoneNumber.toString().localeCompare(b.phoneNumber),
      title: 'Phone Number'
    },
    {
      dataIndex: 'registrationDate',
      key: 'registrationDate',
      render: (registrationDate: Date) => {
        return <Copy text={formatDate(registrationDate || new Date())?.[0] || ''} />;
      },
      sorter: (a: SupplierTableProps, b: SupplierTableProps) =>
        // @ts-ignore
        a.registrationDate.toString().localeCompare(b.registrationDate.toString()),
      title: 'Registration date'
    },
    {
      dataIndex: 'settings',
      key: 'settings',
      render: (settings: ProfileSettings) => {
        return (
          <Copy
            // @ts-ignore
            text={`${settings?.addresses[0]?.name || '-'}, ${
              // @ts-ignore
              settings?.addresses[0]?.street || '-'
              // @ts-ignore
            }, ${settings?.addresses[0]?.apartment || '-'}`}
          />
        );
      },
      sorter: (a: SupplierTableProps, b: SupplierTableProps) =>
        a.address.toString().localeCompare(b.address),
      title: 'Address'
    },
    {
      dataIndex: 'verified',
      key: 'verified',
      render: (verified: boolean) => {
        if (verified) {
          return <Verified />;
        }

        return <NotVerified />;
      },
      title: 'Status'
    },
    {
      key: 'edit',
      render: (supplier: Profile) => {
        return <Tag onClick={() => openDetail(supplier.userId)}>View</Tag>;
      }
    }
  ];

  const actions = [
    {
      onClick: showModalHandler,
      title: 'Create New Seller',
      type: 'primary'
    }
  ];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={data?.paging.total} title="Sellers" />
      <NoxTable
        actions={actions}
        columns={columns}
        // onRowClick={openDetail}
        // filterList={[filterList]}
        // onFilterChange={onFilterChange}
        data={data?.data}
        // selectedFilter={[selectedFilter]}
        searchBy={SearchBy.FULL_NAME}
        // @ts-ignore
        selectedRowKeys={selectedRowKeys}
        // @ts-ignore
        setSelectedRowKeys={setSelectedRowKeys}
      />

      <Modal
        footerActions={
          <>
            <CButton onClick={onCancel} type="secondary" xstyle={{ height: '40px' }}>
              Cancel
            </CButton>
            <CButton onClick={onSave} type="primary" xstyle={{ height: '40px' }}>
              Add
            </CButton>
          </>
        }
        handleClose={onCancel}
        isModalOpen={showModal}
        styles={{
          // @ts-ignore
          '& .MuiDialogContent-root': {
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            justifyContent: 'space-evenly',
            paddingTop: '0px'
          },
          width: '400px'
        }}
        titleContent={<h3 className="modal-title">Create User</h3>}
      >
        <CStandardInput
          disableUnderline
          formclasses={{ root: classes.root }}
          htmlFor="standard-input-user-company-id"
          id="standard-input-user-company-id"
          label="Company id"
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onGenericChange(e.target.value, 'companyId')
          }
          size="large"
          value={sellerData.companyId}
          width="true"
        />
        <CStandardInput
          disableUnderline
          formclasses={{ root: classes.root }}
          htmlFor="standard-input-user-full-name"
          id="standard-input-user-full-name"
          label="Company Name"
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onGenericChange(e.target.value, 'companyName')
          }
          size="large"
          value={sellerData.companyName}
          width="true"
        />
        <CStandardInput
          disableUnderline
          formclasses={{ root: classes.root }}
          htmlFor="standard-input-user-email"
          id="standard-input-user-email"
          label="Email"
          onChange={(e: ChangeEvent<HTMLInputElement>) => onGenericChange(e.target.value, 'email')}
          size="large"
          value={sellerData.email}
          width="true"
        />
        <div className={classes.passwordWrapper}>
          <CStandardInput
            adornment={
              <>
                <img
                  alt="copy password icon"
                  onClick={() => {
                    navigator.clipboard.writeText(sellerData.password);
                  }}
                  src={copyIcon}
                  style={{
                    cursor: 'pointer',
                    marginRight: '5px',
                    width: '18px'
                  }}
                />
                <img
                  alt="hide password icon"
                  onClick={() => {
                    setShowPassword((s) => !s);
                  }}
                  src={showPassword ? OpenEye : ClosedEye}
                  style={{ width: '18px' }}
                />
              </>
            }
            disabled={!!edit}
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-user-password"
            id="standard-input-user-password"
            label="Password"
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              onGenericChange(e.target.value, 'password')
            }
            size="large"
            type={showPassword ? 'text' : 'password'}
            value={sellerData.password}
            width="true"
          />

          <CButton
            onClick={refetchGeneratedPassword}
            type="primary"
            xstyle={{
              borderRadius: '12px',
              margin: '16px 0px 0px 16px'
            }}
          >
            Generate
          </CButton>
        </div>

        <CStandardInput
          disableUnderline
          formclasses={{ root: classes.root }}
          htmlFor="standard-input-user-full-name"
          id="standard-input-user-full-name"
          label="Phone Number"
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onGenericChange(e.target.value, 'phoneNumber')
          }
          size="large"
          value={sellerData.phoneNumber}
          width="true"
        />
        <DefaultSelect
          defaultValue="category"
          onSelect={(value: SellerCategories) => onGenericChange(value, 'category')}
          renderValue={(status: EOrderStatus) => status}
          selectStyles={{
            marginTop: '16px'
          }}
          value={sellerData.category}
        >
          <MenuItem value="">
            <em>Category</em>
          </MenuItem>
          {Object.values(SellerCategories).map((sellerCategory, index) => {
            return (
              <MenuItem key={index} value={sellerCategory}>
                {sellerCategory}
              </MenuItem>
            );
          })}
        </DefaultSelect>
        <div className={classes.uploadWrapper}>
          <Upload
            customRequest={uploadRequest}
            style={{ display: 'none', height: '1px', width: '100%' }}
          >
            <CButton
              ref={inputFile}
              type="primary"
              xstyle={{ height: '40px', marginLeft: '0px', marginTop: '16px', width: '100%' }}
            >
              Upload Image
            </CButton>
          </Upload>
          <div>
            {uploadedImage && (
              <Image
                height={56}
                preview={false}
                src={uploadedImage}
                style={{ objectFit: 'contain' }}
                width={56}
              />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Sellers;
